import { render, staticRenderFns } from "./IndexCharts.vue?vue&type=template&id=ebbc5054&scoped=true&"
import script from "./IndexCharts.vue?vue&type=script&lang=js&"
export * from "./IndexCharts.vue?vue&type=script&lang=js&"
import style0 from "./IndexCharts.vue?vue&type=style&index=0&id=ebbc5054&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbc5054",
  null
  
)

export default component.exports